export default {
  linkToGooglePlay: 'https://play.google.com/store/apps/details?id=com.pinka.app',
  linkToAppStore: 'https://apps.apple.com/ua/app/pinka/id6448631105',
  linkToBaristaGooglePlay: 'https://play.google.com/store/apps/details?id=com.pinka.barista',
  linkToBaristaAppStore: 'https://apps.apple.com/ua/app/pinka-barista/id6448720914',
}
